import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.memoryStepOneCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.memoryStepOneCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) => state.memoryStepOneCollections.data.memoryStepOneCollections,
  (collections = []) => collections
);
const getGroupLabel = createSelector(
  (state) => state.memoryStepOneCollections.data.memoryStepOneGroupLabel,
  (groupLabel = '') => groupLabel
);
const getPageCount = createSelector(
  (state) => state.memoryStepOneCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getGroupLabel,
  getHasLoaded,
  getPageCount,
};
